import { useRef, useEffect, useState } from 'react';

export function useWidth(externalRef?: any) {
  const internalRef = useRef<any>(null);
  const ref = externalRef || internalRef;
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const measure = () => {
      if (ref.current) {
        setWidth(ref.current.offsetWidth || 0);
      }
    };

    const observer = new ResizeObserver(() => {
      measure();
    });

    // Initial messen nach Hydration/Attach
    measure();

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [ref]);

  return [ref, width] as const;
}
